"use strict";
/**
 * This file holds system magic strings
 * such as, end-of-line characters
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHP_EOL = void 0;
/**
 * Port of the PHP_EOL constants
 * For use when receiving PHP responses
 */
exports.PHP_EOL = "\n";
//# sourceMappingURL=magic-string.js.map